/* eslint-disable sort-keys */
import { AxisSwitcher, Clickable, H2, List, P, Separator, Span } from '@ahmdigital/ui';
import getOpeningHours from '@ahmdigital/logic/lib/utils/get-opening-hours';

import { AlertWrapper, StyledSection, StyledWrapper } from './styles';
import constants from '../../../../ahm-constants';
import LifeInsuranceChangeAlert from '../../components/life-insurance-alert';
import PreLineParagraph from '../../components/pre-line-paragraph';

const AXIS_SWITCH_THRESHOLD = '50rem';

const getLifeAndIncomeContent = () => {
  const openingHoursKey = constants.AHM_SERVICE_NAME.LIFE_INSURANCE_ZURICH;

  return {
    meta: {
      title: 'Help and Support - ahm Life Insurance and Income Protection',
      description: 'Need help? Get in touch with us about ahm life insurance.',
    },
    banner: {
      title: 'Help & Support',
      preHeading: 'ahm Life Insurance',
    },
    alert: (
      <AlertWrapper>
        <LifeInsuranceChangeAlert />
      </AlertWrapper>
    ),
    body: (
      <StyledWrapper>
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'limit' is missing in type '{ children: Element[]; threshold: string; space: string; }' but required in type 'Pick<AxisSwitcherProps, "children" | "limit" | "threshold">'. */}
        <AxisSwitcher threshold={AXIS_SWITCH_THRESHOLD} space="2rem">
          <StyledSection theme="grey10">
            <H2 variant="marginBottomSpacer10" looksLike="h5">
              New customers
            </H2>
            <P>Looking for a new life insurance or income protection insurance policy?</P>
            <P>
              Call <Clickable to="tel:1300508940">1300 508 940</Clickable>
            </P>
            <PreLineParagraph>{getOpeningHours(openingHoursKey)}</PreLineParagraph>
            <Separator variant="greyLine" />
            <H2 variant="marginBottomSpacer10" looksLike="h5">
              Know what you want?
            </H2>
            <List variant="withoutListStyle">
              <li>
                <Span>
                  Life insurance -{' '}
                  <Clickable to={constants.URLS.THIRD_PARTY.LIFE_INSURANCE_QUOTE}>get a quick quote</Clickable>
                </Span>
              </li>
              <li>
                <Span>
                  Income protection -{' '}
                  <Clickable to={constants.URLS.THIRD_PARTY.INCOME_INSURANCE_QUOTE}>get a quick quote</Clickable>
                </Span>
              </li>
            </List>
          </StyledSection>
          <StyledSection theme="grey10">
            <H2 variant="marginBottomSpacer10" looksLike="h5">
              Existing customers
            </H2>
            <P>For any existing customer queries including how to make a claim:</P>
            <P>
              <Span variant="bold">Purchased before 1 July 2023 or policy begins with a number - </Span>
              <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_HELP_AND_SUPPORT}>click here</Clickable>
            </P>

            <>
              <P>
                <Span variant="bold">Purchased between 1 July 2023 - 31 March 2024 or policy starts with ‘AL’ - </Span>
                <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_CONTACT_US}>click here</Clickable>
              </P>
              <P>
                <Span variant="bold">Purchased on or after 1 March 2024 or policy starts with ‘AZ’ - </Span>
                <Clickable to={constants.URLS.SALES.LIFE_INSURANCE_CONTACT_US}>click here</Clickable>
              </P>
            </>

            <Separator variant="greyLine" />
            <H2 variant="marginBottomSpacer10" looksLike="h5">
              Not sure?
            </H2>
            <P>
              No problems! Give us a call on <Clickable to="tel:1300052589">1300 052 589</Clickable>
            </P>
          </StyledSection>
        </AxisSwitcher>
      </StyledWrapper>
    ),
  };
};

export default getLifeAndIncomeContent;
